/* tslint:disable */
/* eslint-disable */
/**
 * documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Alternative,
  BatchMoveRequest,
  CheckState200Response,
  Features,
  FileVersion,
  ListsRequest,
  RecordStringStorageNodeArrayOrErrorValue,
  RecordStringStorageNodeOrErrorValue,
  ReferencesOutput,
  ShareId200Response,
  StorageNode,
  TableQuery,
  TableResultStorageWithIndexCount,
  Template,
} from '../models/index';

export interface StorageApiExistsRequest {
    tenant: string;
    path: string;
}

export interface StorageApiAlternativesRequest {
    tenant: string;
    path: string;
}

export interface StorageApiAlternativesInstanceRequest {
    tenant: string;
    fromInstance: string;
    path: string;
}

export interface StorageApiBatchCopyRequest {
    tenant: string;
    batchMoveRequest: BatchMoveRequest;
}

export interface StorageApiBatchMoveOperationRequest {
    tenant: string;
    batchMoveRequest: BatchMoveRequest;
}

export interface StorageApiCheckStateRequest {
    tenant: string;
    path: string;
}

export interface StorageApiCopyRequest {
    tenant: string;
    oldpath: string;
    newpath: string;
}

export interface StorageApiCreateFileRequest {
    tenant: string;
    filepath: string;
    recursive?: boolean;
}

export interface StorageApiCreateFolderRequest {
    tenant: string;
    folderpath: string;
    recursive?: boolean;
}

export interface StorageApiDownloadRequest {
    tenant: string;
    filepath: string;
}

export interface StorageApiFeaturesRequest {
    tenant: string;
    path: string;
}

export interface StorageApiGetRequest {
    tenant: string;
    path: string;
}

export interface StorageApiGetsRequest {
    tenant: string;
    listsRequest: ListsRequest;
}

export interface StorageApiIndexTableRequest {
    tenant: string;
    path: string;
    tableQuery: TableQuery;
}

export interface StorageApiListRequest {
    tenant: string;
    path: string;
}

export interface StorageApiListTemplatesRequest {
    tenant: string;
}

export interface StorageApiListsOperationRequest {
    tenant: string;
    listsRequest: ListsRequest;
}

export interface StorageApiMoveRequest {
    tenant: string;
    oldpath: string;
    newpath: string;
}

export interface StorageApiPathsForShareIdRequest {
    tenant: string;
    key: string;
}

export interface StorageApiReferencesRequest {
    tenant: string;
    path: string;
}

export interface StorageApiRemoveRequest {
    tenant: string;
    path: string;
}

export interface StorageApiRemoveFinallyRequest {
    tenant: string;
    path: string;
}

export interface StorageApiReplaceRequest {
    tenant: string;
    instance: string;
    oldpath: string;
    newpath: string;
}

export interface StorageApiShareIdRequest {
    tenant: string;
    path: string;
}

export interface StorageApiUploadRequest {
    tenant: string;
    filepath: string;
    recursive?: boolean;
    backup?: boolean;
    body?: Blob;
}

export interface StorageApiVersionsRequest {
    tenant: string;
    path: string;
}

/**
 * 
 */
export class StorageApi extends runtime.BaseAPI {

    /**
     */
    async _existsRaw(requestParameters: StorageApiExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling _exists().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling _exists().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/exists`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async _exists(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this._existsRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async alternativesRaw(requestParameters: StorageApiAlternativesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Alternative>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling alternatives().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling alternatives().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/alternatives`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async alternatives(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Alternative>> {
        const response = await this.alternativesRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async alternativesInstanceRaw(requestParameters: StorageApiAlternativesInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Alternative>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling alternativesInstance().'
            );
        }

        if (requestParameters['fromInstance'] == null) {
            throw new runtime.RequiredError(
                'fromInstance',
                'Required parameter "fromInstance" was null or undefined when calling alternativesInstance().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling alternativesInstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fromInstance'] != null) {
            queryParameters['fromInstance'] = requestParameters['fromInstance'];
        }

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/alternativesInstance`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async alternativesInstance(tenant: string, fromInstance: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Alternative>> {
        const response = await this.alternativesInstanceRaw({ tenant: tenant, fromInstance: fromInstance, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async batchCopyRaw(requestParameters: StorageApiBatchCopyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Error; }>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling batchCopy().'
            );
        }

        if (requestParameters['batchMoveRequest'] == null) {
            throw new runtime.RequiredError(
                'batchMoveRequest',
                'Required parameter "batchMoveRequest" was null or undefined when calling batchCopy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/batchCopy`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['batchMoveRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async batchCopy(tenant: string, batchMoveRequest: BatchMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Error; }> {
        const response = await this.batchCopyRaw({ tenant: tenant, batchMoveRequest: batchMoveRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async batchMoveRaw(requestParameters: StorageApiBatchMoveOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Error; }>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling batchMove().'
            );
        }

        if (requestParameters['batchMoveRequest'] == null) {
            throw new runtime.RequiredError(
                'batchMoveRequest',
                'Required parameter "batchMoveRequest" was null or undefined when calling batchMove().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/batchMove`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['batchMoveRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async batchMove(tenant: string, batchMoveRequest: BatchMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Error; }> {
        const response = await this.batchMoveRaw({ tenant: tenant, batchMoveRequest: batchMoveRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async checkStateRaw(requestParameters: StorageApiCheckStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckState200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling checkState().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling checkState().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/checkState`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async checkState(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckState200Response> {
        const response = await this.checkStateRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async copyRaw(requestParameters: StorageApiCopyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling copy().'
            );
        }

        if (requestParameters['oldpath'] == null) {
            throw new runtime.RequiredError(
                'oldpath',
                'Required parameter "oldpath" was null or undefined when calling copy().'
            );
        }

        if (requestParameters['newpath'] == null) {
            throw new runtime.RequiredError(
                'newpath',
                'Required parameter "newpath" was null or undefined when calling copy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['oldpath'] != null) {
            queryParameters['oldpath'] = requestParameters['oldpath'];
        }

        if (requestParameters['newpath'] != null) {
            queryParameters['newpath'] = requestParameters['newpath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/copy`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async copy(tenant: string, oldpath: string, newpath: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.copyRaw({ tenant: tenant, oldpath: oldpath, newpath: newpath }, initOverrides);
    }

    /**
     */
    async createFileRaw(requestParameters: StorageApiCreateFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling createFile().'
            );
        }

        if (requestParameters['filepath'] == null) {
            throw new runtime.RequiredError(
                'filepath',
                'Required parameter "filepath" was null or undefined when calling createFile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filepath'] != null) {
            queryParameters['filepath'] = requestParameters['filepath'];
        }

        if (requestParameters['recursive'] != null) {
            queryParameters['recursive'] = requestParameters['recursive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/createFile`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createFile(tenant: string, filepath: string, recursive?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createFileRaw({ tenant: tenant, filepath: filepath, recursive: recursive }, initOverrides);
    }

    /**
     */
    async createFolderRaw(requestParameters: StorageApiCreateFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling createFolder().'
            );
        }

        if (requestParameters['folderpath'] == null) {
            throw new runtime.RequiredError(
                'folderpath',
                'Required parameter "folderpath" was null or undefined when calling createFolder().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['folderpath'] != null) {
            queryParameters['folderpath'] = requestParameters['folderpath'];
        }

        if (requestParameters['recursive'] != null) {
            queryParameters['recursive'] = requestParameters['recursive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/createFolder`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createFolder(tenant: string, folderpath: string, recursive?: boolean, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createFolderRaw({ tenant: tenant, folderpath: folderpath, recursive: recursive }, initOverrides);
    }

    /**
     */
    async downloadRaw(requestParameters: StorageApiDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling download().'
            );
        }

        if (requestParameters['filepath'] == null) {
            throw new runtime.RequiredError(
                'filepath',
                'Required parameter "filepath" was null or undefined when calling download().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filepath'] != null) {
            queryParameters['filepath'] = requestParameters['filepath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/download`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async download(tenant: string, filepath: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadRaw({ tenant: tenant, filepath: filepath }, initOverrides);
        return await response.value();
    }

    /**
     */
    async featuresRaw(requestParameters: StorageApiFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Features>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling features().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling features().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/features`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async features(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Features> {
        const response = await this.featuresRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRaw(requestParameters: StorageApiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageNode>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling get().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/get`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async get(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageNode> {
        const response = await this.getRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getsRaw(requestParameters: StorageApiGetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: RecordStringStorageNodeOrErrorValue; }>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling gets().'
            );
        }

        if (requestParameters['listsRequest'] == null) {
            throw new runtime.RequiredError(
                'listsRequest',
                'Required parameter "listsRequest" was null or undefined when calling gets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/gets`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['listsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async gets(tenant: string, listsRequest: ListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: RecordStringStorageNodeOrErrorValue; }> {
        const response = await this.getsRaw({ tenant: tenant, listsRequest: listsRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async indexTableRaw(requestParameters: StorageApiIndexTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TableResultStorageWithIndexCount>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling indexTable().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling indexTable().'
            );
        }

        if (requestParameters['tableQuery'] == null) {
            throw new runtime.RequiredError(
                'tableQuery',
                'Required parameter "tableQuery" was null or undefined when calling indexTable().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/index/overview`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['tableQuery'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async indexTable(tenant: string, path: string, tableQuery: TableQuery, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TableResultStorageWithIndexCount> {
        const response = await this.indexTableRaw({ tenant: tenant, path: path, tableQuery: tableQuery }, initOverrides);
        return await response.value();
    }

    /**
     */
    async listRaw(requestParameters: StorageApiListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StorageNode>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling list().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling list().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/list`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async list(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StorageNode>> {
        const response = await this.listRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async listTemplatesRaw(requestParameters: StorageApiListTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Template>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling listTemplates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/listTemplates`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async listTemplates(tenant: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Template>> {
        const response = await this.listTemplatesRaw({ tenant: tenant }, initOverrides);
        return await response.value();
    }

    /**
     */
    async listsRaw(requestParameters: StorageApiListsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: RecordStringStorageNodeArrayOrErrorValue; }>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling lists().'
            );
        }

        if (requestParameters['listsRequest'] == null) {
            throw new runtime.RequiredError(
                'listsRequest',
                'Required parameter "listsRequest" was null or undefined when calling lists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/lists`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['listsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async lists(tenant: string, listsRequest: ListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: RecordStringStorageNodeArrayOrErrorValue; }> {
        const response = await this.listsRaw({ tenant: tenant, listsRequest: listsRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async moveRaw(requestParameters: StorageApiMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling move().'
            );
        }

        if (requestParameters['oldpath'] == null) {
            throw new runtime.RequiredError(
                'oldpath',
                'Required parameter "oldpath" was null or undefined when calling move().'
            );
        }

        if (requestParameters['newpath'] == null) {
            throw new runtime.RequiredError(
                'newpath',
                'Required parameter "newpath" was null or undefined when calling move().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['oldpath'] != null) {
            queryParameters['oldpath'] = requestParameters['oldpath'];
        }

        if (requestParameters['newpath'] != null) {
            queryParameters['newpath'] = requestParameters['newpath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/move`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async move(tenant: string, oldpath: string, newpath: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.moveRaw({ tenant: tenant, oldpath: oldpath, newpath: newpath }, initOverrides);
    }

    /**
     */
    async pathsForShareIdRaw(requestParameters: StorageApiPathsForShareIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling pathsForShareId().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling pathsForShareId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/tenant/{tenant}/pathsForShareId`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async pathsForShareId(tenant: string, key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.pathsForShareIdRaw({ tenant: tenant, key: key }, initOverrides);
        return await response.value();
    }

    /**
     */
    async referencesRaw(requestParameters: StorageApiReferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferencesOutput>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling references().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling references().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/references`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async references(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferencesOutput> {
        const response = await this.referencesRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeRaw(requestParameters: StorageApiRemoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling remove().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling remove().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/remove`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async remove(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeRaw({ tenant: tenant, path: path }, initOverrides);
    }

    /**
     */
    async removeFinallyRaw(requestParameters: StorageApiRemoveFinallyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling removeFinally().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling removeFinally().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/removeFinally`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeFinally(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeFinallyRaw({ tenant: tenant, path: path }, initOverrides);
    }

    /**
     */
    async replaceRaw(requestParameters: StorageApiReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling replace().'
            );
        }

        if (requestParameters['instance'] == null) {
            throw new runtime.RequiredError(
                'instance',
                'Required parameter "instance" was null or undefined when calling replace().'
            );
        }

        if (requestParameters['oldpath'] == null) {
            throw new runtime.RequiredError(
                'oldpath',
                'Required parameter "oldpath" was null or undefined when calling replace().'
            );
        }

        if (requestParameters['newpath'] == null) {
            throw new runtime.RequiredError(
                'newpath',
                'Required parameter "newpath" was null or undefined when calling replace().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instance'] != null) {
            queryParameters['instance'] = requestParameters['instance'];
        }

        if (requestParameters['oldpath'] != null) {
            queryParameters['oldpath'] = requestParameters['oldpath'];
        }

        if (requestParameters['newpath'] != null) {
            queryParameters['newpath'] = requestParameters['newpath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/replace`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async replace(tenant: string, instance: string, oldpath: string, newpath: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceRaw({ tenant: tenant, instance: instance, oldpath: oldpath, newpath: newpath }, initOverrides);
    }

    /**
     */
    async shareIdRaw(requestParameters: StorageApiShareIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShareId200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling shareId().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling shareId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/shareid`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shareId(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShareId200Response> {
        const response = await this.shareIdRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadRaw(requestParameters: StorageApiUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling upload().'
            );
        }

        if (requestParameters['filepath'] == null) {
            throw new runtime.RequiredError(
                'filepath',
                'Required parameter "filepath" was null or undefined when calling upload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filepath'] != null) {
            queryParameters['filepath'] = requestParameters['filepath'];
        }

        if (requestParameters['recursive'] != null) {
            queryParameters['recursive'] = requestParameters['recursive'];
        }

        if (requestParameters['backup'] != null) {
            queryParameters['backup'] = requestParameters['backup'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/upload`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upload(tenant: string, filepath: string, recursive?: boolean, backup?: boolean, body?: Blob, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadRaw({ tenant: tenant, filepath: filepath, recursive: recursive, backup: backup, body: body }, initOverrides);
    }

    /**
     */
    async versionsRaw(requestParameters: StorageApiVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FileVersion>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling versions().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling versions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/revision/versions`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async versions(tenant: string, path: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FileVersion>> {
        const response = await this.versionsRaw({ tenant: tenant, path: path }, initOverrides);
        return await response.value();
    }

}
